// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { DataReturnType, DetailType } from "../../types"

// Utils
import { useApi } from "utils"

// Types
interface DataType {
  datareturn: DataReturnType,
  detailreturn: DetailType[]
}
type Type = DataType | null

export function useDetail(return_id?: string): {
  data: Type
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/return/detailreturn",
      { params: { return_id } }
    ).then((res: SuccessFetch<{
      payload: DataType
    }>) => {
      setData(res.data.payload)
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}